/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { BlIcon, BlIconType } from '@blend/shared-react';
import { ErrorMessage } from './Message';

export namespace Error {
  export interface Props {
    error: string;
    icon?: BlIconType;
  }
}

export const Error: React.SFC<Error.Props> = ({ error, icon = 'error-2' }) => {
  return (
    <>
      <BlIcon icon={icon} lineHeight={1.2} />
      <ErrorMessage>{error}</ErrorMessage>
    </>
  );
};
